import { Ticket, TicketSite, TicketPriority } from '../../../entities/ticket/model/types';
import { createTicket as createTicketApi } from '../../../entities/ticket/api/ticketApi';

export interface CreateTicketRequest {
  title: string;
  site: TicketSite;
  clientEmail: string;
  priority: TicketPriority;
  category?: string;
  initialMessage?: string;
}

export class CreateTicketUseCase {
  async execute(request: CreateTicketRequest): Promise<Ticket> {
    return await createTicketApi({
      title: request.title,
      site: request.site,
      clientEmail: request.clientEmail,
      priority: request.priority,
      category: request.category,
      initialMessage: request.initialMessage,
    });
  }
}




